import { GhostButton } from 'ui/button';
import { useTranslation } from 'modules/domains/list';
import { useFiltersContext } from '../../contexts';

export const DATA_TEST = {
  button: 'clear-filter-button',
};

export const ClearFiltersButton = () => {
  const { t } = useTranslation();
  const { types, setTypes } = useFiltersContext();

  return (
    Boolean(types.length) && (
      <GhostButton data-test={DATA_TEST.button} onClick={() => setTypes([])}>
        {t('indexPage.filters.clear')}
      </GhostButton>
    )
  );
};
